import * as React from "react";
import { Stack, Tooltip } from "@mui/material";
import type { OssatureChapterItem } from "../../api/coverage/coverage";
import { StatusPill } from "../ui/StatusPill";
import { describeIssues, type ChapterIssue } from "./chapterIssues";

interface Props {
  chapter: OssatureChapterItem;
  /** Défauts déjà dits ailleurs sur la ligne (pastille d'état, colonne État). */
  exclude?: ChapterIssue[];
  /** Rien à signaler : ce nœud (ex. « Complet »), sinon rien. */
  empty?: React.ReactNode;
}

/** Défauts d'un chapitre en pastilles, chacune avec son infobulle (ce que ça veut dire, quoi faire). */
export const IssuePills: React.FC<Props> = ({ chapter, exclude = [], empty = null }) => {
  const badges = describeIssues(chapter).filter((b) => !exclude.includes(b.issue));
  if (!badges.length) return <>{empty}</>;
  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {badges.map((b) => (
        <Tooltip key={b.issue} title={b.hint}>
          <span>
            <StatusPill tone={b.tone}>{b.label}</StatusPill>
          </span>
        </Tooltip>
      ))}
    </Stack>
  );
};

export default IssuePills;
